
    import Vue from "vue";
    import * as toastr from "toastr";
    import AllocationTab from "@/views/Modals/BookingsModals/Tabs/AllocationTab.vue"
    import HotelsTab from "@/views/Modals/BookingsModals/Tabs/HotelsTab.vue"
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import DetailsTab from "@/views/Modals/BookingsModals/Tabs/DetailsTab.vue"
    import EmployeesTab from "@/views/Modals/BookingsModals/Tabs/EmployeesTab.vue"
    import ItineraryReportSendModal from "@/views/Modals/BookingsModals/ItineraryReportSendModal.vue";
    import ScanReportModal from "@/views/Modals/BookingsModals/ScanReportModal.vue"
    import store from "@/store/store";
    import Loader from "@/views/Loader.vue"
    import { ApiClient } from "@/utilities/ApiClient";
    import { BookingProfile, IBookingProfile } from "@/model/BookingProfile";
    import { Booking } from "@/model/Booking";
    import { BookingRoomTotalsVM, IBookingRoomTotalsVM } from "@/model/Api/VM/BookingRoomTotalsVM";
    import { BookingHotelVM, IBookingHotelVM } from "@/model/Api/VM/BookingHotelVM";
    import { ButtonToggler } from "@/utilities/ButtonToggler";
    import { BookingVM } from "@/model/Api/VM/BookingVM";
    import { Contractor } from "@/model/Contractor";
    import { Employee, IEmployee } from "@/model/Employee";
    import { IBookingAllocationVM, BookingAllocationVM } from "../../../model/Api/VM/BookingAllocationVM";
    import { Utils } from "@/utilities/Utils";
    import { Validations } from "vuelidate-property-decorators";
    import { Watch } from "vue-property-decorator";
    import { required } from "vuelidate/lib/validators";
    import { EmployeeVM, IEmployeeVM } from "@/model/Api/VM/EmployeeVM";
    import ConfirmBookingModal from "@/views/Modals/BookingsModals/ConfirmBookingModal.vue";
    import DeleteBookingModal from "@/views/Modals/BookingsModals/DeleteBookingModal.vue";
    import SubmitBookingModal from "@/views/Modals/BookingsModals/SubmitBookingModal.vue";
    import ReportSettingsTab from "@/views/Modals/BookingsModals/Tabs/ReportSettingsTab.vue";
    import { ContractorDefaultScanTimes } from '@/model/ContractorDefaultScanTimes';
    import { User, IUser } from "@/model/User";
    import { CostCode, ICostCode } from "@/model/CostCode";

    //TODO ADD ACTIONS.length to the disabled filter on delete button: <api-button variant="outline-danger" v-if="!booking.isNew && actions.length == 0" icon="fa-trash-alt" @click="deleteBooking($event)">Delete</api-button>
    //TODO IF the biggest no. of rooms for one night exceeds the no. of employees on submit request show a warning

    @Component({
        components: {
            AllocationTab,
            ApiButton,
            DetailsTab,
            EmployeesTab,
            ItineraryReportSendModal,
            Loader,
            ConfirmBookingModal,
            DeleteBookingModal,
            SubmitBookingModal,
            ReportSettingsTab,
            ScanReportModal,
            HotelsTab
        }
    })

    export default class BookingModal extends Vue {

        //
        // -- lifecycle hooks (https://vuejs.org/v2/guide/instance.html#Instance-Lifecycle-Hooks)
        //

        async mounted() {
            const contractorServerData = await ApiClient.get(`Api/Contractor/GetContractor?id=${store.state.signedInUser?.guid}`);
            this.contractor.update(contractorServerData);
            this.contractorID = this.contractor.id;
            this.signedInUser = this.$store.state.signedInUser;
        }

        //
        // -- properties
        //

        activeTabID = "detail";
        bookingID: number = 0;
        contractorID: number = 0;
        isLoadingAllocations: boolean = false;
        isLoadingProfile: boolean = false;
        isLoadingTotals: boolean = false;
        requiresSave: boolean = false;
        locationValidation = false;

        private bookingAllocations: Array<IBookingAllocationVM> = [];
        private bookingProfiles: Array<IBookingProfile> = [];
        private contractor = new Contractor();
        private employees: Array<IEmployee> = [];
        private booking = new BookingVM();
        private roomTotals: Array<IBookingRoomTotalsVM> = [];
        private loaderActive: boolean = false;
        private availableEmployees: Array<IEmployeeVM> = [];
        readonly contractorDefaultScanTimes = new ContractorDefaultScanTimes();
        private originalFirstStay: Date = new Date();
        private originalLastStay: Date = new Date();
        private signedInUser = new User();
        private costCodes: Array<CostCode> = [];
        private hotels: Array<BookingHotelVM> = [];
        private renderMap: number = 0;


        // computed property

        private get dialogueTitle(): string {
            if (!this.booking) return "- - -";
            if (Utils.isEmptyId(this.booking.guid)) return "New Booking";
            if (this.booking.statusID == 1) return "Booking " + this.booking.id + ", " + this.booking.status;
            if (this.booking.statusID == 2) return "Booking " + this.booking.id + ", " + this.booking.status;
            if (this.booking.statusID == 3) return "Booking " + this.booking.id + ", " + this.booking.status + " - Contact admin to change"
            if (this.booking.statusID == 4) return "Booking " + this.booking.id + ", " + this.booking.status + " - Contact admin to change"
            if (this.booking.statusID == 5) return "Booking " + this.booking.id + ", " + this.booking.status + " - Contact admin to change"
            if (this.booking.statusID == 6) return "Booking " + this.booking.id + ", " + this.booking.status + " - Contact admin to change"
            if (this.booking.statusID == 7) return "Booking " + this.booking.id + ", " + this.booking.status + " - Contact admin to change"
            if (this.booking.statusID == 8) return "Booking " + this.booking.id + ", " + this.booking.status + " - Contact admin to change"
            return "Edit Booking " + this.booking.id + " - " + this.booking.status;
        }

        private get disableTabs(): boolean {
            if (Utils.isEmptyId(this.booking.guid)) return true;
            return false;
        }

        private get canDelete() { return !this.booking.isNew; }

        private get canActivate() { return !this.booking.isNew; }

        private get isDisabled() {
            if (this.booking.statusID === 3) { return true }
            //if (this.booking.statusID === 4) { return true }
            if (this.booking.statusID === 5) { return true }
            if (this.booking.statusID === 6) { return true }
            if (this.booking.statusID === 8) { return true }
            else return false;
        }

        private get totalNights(): number {
            let retVal = 0;
            if (this.bookingProfiles.length > 0) {
                for (const profile of this.bookingProfiles) {
                    retVal += +profile.noOfRooms
                }
            }
            return retVal;
        }

        // Watchers

        @Watch("booking.worksPostCode")
        @Watch("booking.description")
        @Watch("booking.foodAllowance")
        @Watch("booking.parkingRequirements")
        @Watch("booking.costCodeID")
        @Watch("booking.contractorHotelNotes")
        @Watch("booking.additionalComments", { immediate: true, deep: true })
        onWatchedChanged(value: any) {
            this.requiresSave = true;
        }

        @Watch("booking.latestArrivalDefaultTime", { immediate: false, deep: false })
        latestArrivalDefaultTime(value: any) {
            this.booking.hasDefaultLatestArrival = true;
            this.requiresSave = true;
        }

        //
        // -- methods
        //

        activateDetailTab() {
            this.activeTabID = 'detail';
            this.renderMap++;
        }

        confirmDisabledText() {
            if (this.booking.confirmDisabled) {
                return "First stay is in the past. Contact admin to confirm."
            }
            else {
                return "Please select a preferred hotel"
            }
        }

        async setRequiresSave() {
            if (!this.requiresSave) return this.requiresSave = true;
        }

        async noRequireSave() {
            setTimeout(() => this.requiresSave = false, 200);
        }

        show() {
            if (this.booking.isNew && this.contractor.defaultBookingOnly) {
                this.booking.isBookingOnly = true;
            }
            if (this.booking.isNew) {
                this.booking.hasDefaultLatestArrival = false;
                this.bookingAllocations = [];
                this.bookingProfiles = [];
                this.roomTotals = [];
            }
            this.activeTabID = "detail";
            // this.booking.firstStay = new Date();
            // this.booking.lastStay = new Date();
            this.availableEmployees = [];
            this.loadCostCodes();
            this.$v.$reset();
            this.$bvModal.show("bookingModal")
        }

        async editBooking(bookingID: number) {
            this.activeTabID = "detail";
            this.$v.$reset();
            this.bookingID = bookingID;
            await this.loadBooking();
            console.log(this.booking.statusID);
            if (this.booking.statusID == 4) this.activeTabID = "hotels";
            this.loadProfiles();
            this.loadEmployees();
            this.loadRoomTotals();
            this.loadAllocationsDetail();
            this.loadAvailableEmployees();
            this.loadContractor();
            this.loadCostCodes();
            this.loadHotels();
            this.requiresSave = false;
            this.$bvModal.show("bookingModal");
        }


        async loadContractor() {
            const serverContractorData = await ApiClient.get(`api/contractor/ContractorDefaultScanTimes?id=${Utils.emptyGuidValue}&intID=${this.booking.contractorID}`);
            this.contractorDefaultScanTimes.update(serverContractorData);
            
        }

        async loadLookups(event?: Event) { return null; }

        async loadProfiles() {
            if (this.isLoadingProfile) { return; }
            this.isLoadingProfile = true;
            this.bookingProfiles = [];
            const response = await ApiClient.get(`/Api/Booking/BookingProfiles?id=${this.bookingID}`);
            this.bookingProfiles.push(...response.map((c: IBookingProfile) => new BookingProfile(c)));
            this.isLoadingProfile = false;
        }

        async loadEmployees() {
            this.employees = [];
            const response = await ApiClient.get(`/Api/Booking/GetBookingEmployees?bookingID=${this.bookingID}`);
            this.employees.push(...response.map((e: IEmployee) => new Employee(e)));
        }

        async loadCostCodes(event?: Event) {
            this.costCodes = [];
            const response = await ApiClient.get(`/Api/Contractor/CostCodesID?id=${this.contractorID}`);
            this.costCodes.push(...response.map((e: ICostCode) => new CostCode(e)));
        }

        async loadAvailableEmployees() {
            this.availableEmployees = [];
            const response = await ApiClient.get(`/Api/Booking/ActiveEmployeeSearch?contractorID=${this.contractorID}&bookingID=${this.bookingID}`);
            this.availableEmployees.push(...response.map((e: IEmployeeVM) => new EmployeeVM(e)));
        }

        async loadBooking() {
            this.$v.$reset();
            Utils.resetObject(this.booking);
            const bookingData = await ApiClient.get(`api/booking/GetBooking?id=${this.bookingID}`);
            this.booking.update(bookingData);
            this.originalFirstStay = this.booking.firstStay;
            this.originalLastStay = this.booking.lastStay;
        }

        async loadAllocationsDetail() {
            if (this.isLoadingAllocations) {
                return;
            }
            this.isLoadingAllocations = true;
            this.bookingAllocations = [];
            this.loaderActive = Utils.showLoader();
            const response = await ApiClient.get(`/Api/Booking/GetAllocations?id=${this.bookingID}`);
            this.loaderActive = Utils.hideLoader();
            this.bookingAllocations.push(...response.map((a: IBookingAllocationVM) => new BookingAllocationVM(a)));
            this.isLoadingAllocations = false;

        }

        async loadRoomTotals() {
            if (this.isLoadingTotals) { return; }
            this.isLoadingTotals = true;
            this.roomTotals = [];
            const response = await ApiClient.get(`/Api/Booking/BookingRoomTotals?id=${this.bookingID}`);
            this.roomTotals.push(...response.map((r: IBookingRoomTotalsVM) => new BookingRoomTotalsVM(r)));
            this.isLoadingTotals = false;
        }

        async loadHotels(event?: Event) {
            this.hotels = [];
            const response = await ApiClient.get(`/Api/Booking/Hotels?id=${this.bookingID}`);
            this.hotels.push(...response.map((e: IBookingHotelVM) => new BookingHotelVM(e)));
        }

        async initialSave(event: Event) {
            this.booking.contractorID = this.contractorID;
            this.booking.contractorAdminID = this.signedInUser.id;
            const button = ButtonToggler.getButton(event);
            ButtonToggler.disableButton(button);
            if (this.booking.worksLatitude > 0) {
                this.locationValidation = true;
            }
            else {
                this.locationValidation = false;
            }
            if (!await this.isValid()) {
                this.validationToastr(this.booking)
                ButtonToggler.enableButton(button);
                return;
            }

            // set latest arrival default to the firststay date to ensure booking is not in the past //
            const year = this.booking.firstStay.getFullYear();
            const month = this.booking.firstStay.getMonth();
            const day = this.booking.firstStay.getDate();
            this.booking.latestArrivalDefault.setFullYear(year);
            this.booking.latestArrivalDefault.setMonth(month);
            this.booking.latestArrivalDefault.setDate(day);

            if (this.booking.latestArrivalDefault < new Date()) {
                toastr.warning("Selected check in time is in the past.")
                ButtonToggler.enableButton(button);
                return;
            }
            ButtonToggler.enableButton(button);
            this.booking.contractorID = this.contractorID;
            this.loaderActive = Utils.showLoader();
            const response = await ApiClient.post("/Api/Booking/InitialSave", this.booking, event);
            this.loaderActive = Utils.hideLoader();
            this.bookingID = response;
            toastr.success("Saved");
            this.$emit("refreshSearch");
            this.loadBooking();
            this.loadProfiles();
            this.loadEmployees();
            await this.loadAvailableEmployees();
            await this.loadContractor();
            this.requiresSave = false;
        }

        async refreshSearch() {
            this.$emit("refreshSearch");
        }

        //noOfEmployeesCheck() {
        //    const sortedProfiles = this.bookingProfiles.sort((first, second) => 0 - (first.noOfRooms > second.noOfRooms ? 1 : -1));//sorts the profiles by noOfRooms
        //    const mostNoOfNights = sortedProfiles[0].noOfRooms //get the largest no. of rooms.
        //    const noOfEmployees = this.employees.length; // get the no. of employees
        //    if (noOfEmployees < mostNoOfNights) { return true } //if the no. of employees on one night exceeds the profile with the biggest no. of nights
        //    else return false;
        //}

        async save(event: Event) {
            console.log(this.booking.firstStay)
            console.log(this.booking.lastStay)
            const button = ButtonToggler.getButton(event);
            ButtonToggler.disableButton(button);
            if (!await this.isValid()) {
                this.validationToastr(this.booking)
                ButtonToggler.enableButton(button);
                return;
            }

            // set latest arrival default to the firststay date to ensure booking is not in the past //
            const year = this.booking.firstStay.getFullYear();
            const month = this.booking.firstStay.getMonth();
            const day = this.booking.firstStay.getDate();
            this.booking.latestArrivalDefault.setFullYear(year);
            this.booking.latestArrivalDefault.setMonth(month);
            this.booking.latestArrivalDefault.setDate(day);

            if (this.booking.latestArrivalDefault < new Date()) {
                toastr.warning("Selected check in time is in the past.")
                ButtonToggler.enableButton(button);
                return;
            }
            ButtonToggler.enableButton(button);
            this.loaderActive = Utils.showLoader();
            await ApiClient.post("/Api/Booking/SaveBooking", this.booking, event);
            this.loaderActive = Utils.hideLoader();
            toastr.success("Saved");
            this.$bvModal.hide("bookingModal");
            Utils.resetObject(this.booking);
            this.requiresSave = false;
            this.$emit("refreshSearch");
        }

        async bookingProfileSave(event: Event) {
            this.loaderActive = Utils.showLoader();
            await ApiClient.post("/Api/Booking/ProfileSave", this.bookingProfiles, event);
            this.loaderActive = Utils.hideLoader();
            this.loadProfiles();
            this.loadEmployees();
            this.loadRoomTotals();
            toastr.success("Saved Booking Profile");
            this.loadAllocationsDetail();
            this.loadRoomTotals();
            this.$bvModal.hide("bookingProfileModal");
        }

        async saveBookingDates(event?: Event) {
            if (this.booking.id == 0 || !Utils.hasDateValue(this.booking.firstStay) || !Utils.hasDateValue(this.booking.lastStay)) {
                return;
            } else {
                this.loaderActive = Utils.showLoader();
                await ApiClient.post("/Api/Booking/BookingDatesSave", this.booking, event);
                this.originalFirstStay = this.booking.firstStay;
                this.originalLastStay = this.booking.lastStay;
                this.loaderActive = Utils.hideLoader();
                this.loadBooking();
                this.loadProfiles();
                this.loadAllocationsDetail();
                this.loadRoomTotals();
                this.$emit("refreshSearch");
                // this.booking.totalDays = Math.abs(this.booking.firstStay.getDate() - this.booking.lastStay.getDate()) + 1;
            }
            toastr.success("Saved booking dates")
        }

        async saveLatestArrivalDefaultTime(event: Event) {
            if (this.booking.id == 0 || !Utils.hasDateValue(this.booking.latestArrivalDefaultTime)) { return; } else {
                this.loaderActive = Utils.showLoader();
                await ApiClient.post("/Api/Booking/AllocationCheckInTimeSave", this.booking, event);
                this.loaderActive = Utils.hideLoader();
                this.loadProfiles();
                this.loadAllocationsDetail();
                this.loadRoomTotals();
                this.booking.totalDays = Math.abs(this.booking.firstStay.getDate() - this.booking.lastStay.getDate()) + 1;
            }
        }

        async cancel() {
            if (this.requiresSave && !this.booking.isNew) {
                const shouldClose: boolean = await this.$bvModal.msgBoxConfirm("Changes have been made to the booking detail, please save.", {
                    title: "Save Warning",
                    okVariant: "info",
                    okTitle: "Return to save",
                    cancelTitle: "Close anyway",
                    hideHeaderClose: true,
                    centered: true,
                    headerClass: "border-bottom-0",
                    footerClass: "border-top-0",
                    size: "sm"
                });
                if (shouldClose) return;
            }
            store.dispatch("setBookingID", this.booking.id)
            this.$emit("refreshSearch");
            this.$bvModal.hide("bookingModal");
            Utils.resetObject(this.booking);
            this.bookingProfiles = [];
        }

        async deleteBooking() {
            this.booking.hasDefaultLatestArrival = false;
            const dialogue = this.$refs.deleteBookingModal as DeleteBookingModal & { show: () => void };
            dialogue.show(this.booking);
        }

        async submitBooking(event: Event) {
            this.booking.hasDefaultLatestArrival = false;

            // set latest arrival default to the firststay date to ensure booking is not in the past //
            const year = this.booking.firstStay.getFullYear();
            const month = this.booking.firstStay.getMonth();
            const day = this.booking.firstStay.getDate();
            this.booking.latestArrivalDefault.setFullYear(year);
            this.booking.latestArrivalDefault.setMonth(month);
            this.booking.latestArrivalDefault.setDate(day);
            if (this.booking.latestArrivalDefault < new Date()) {
                toastr.warning("Selected check in time is in the past.")
                return;
            }

            const dialogue = this.$refs.submitBookingModal as SubmitBookingModal & { show: () => void };
            dialogue.show(this.booking, this.employees);
        }

        async validateRequest() {
            const button = ButtonToggler.getButton(event);
            ButtonToggler.disableButton(button);
            if (!await this.isValid()) {
                this.validationToastr(this.booking)
                ButtonToggler.enableButton(button);
                return;
            }
            ButtonToggler.enableButton(button);
            this.$bvModal.show("submitRequest");
        }

        async cancelRequest(event: Event) {
            this.booking.statusID = 1;
            const response = await ApiClient.post("/Api/Booking/SaveBooking", this.booking, event);
            if (response.message == "ok") {
                const emailResp = await ApiClient.post("/Api/Booking/sendCancelRequestEmail", this.booking);
                if (emailResp.message == "ok") {
                    toastr.warning("Request cancelled");
                    this.$emit("refreshSearch");
                    Utils.resetObject(this.booking);
                    this.$bvModal.hide("cancelBooking");
                    this.$bvModal.hide("bookingModal");
                }
            }
        }

        private async isValid(): Promise<boolean> {
            const detailsTab = this.$refs.detailsTab as DetailsTab & { isDetailsValid: () => void };
            detailsTab.isDetailsValid();
            this.$v.$reset();
            this.$v.$touch();
            await this.waitForValidation();
            return Promise.resolve(!this.$v.$error);
        }

        async downloadBookingItinerary() {
            this.loaderActive = Utils.showLoader();
            const blob: Blob = await ApiClient.get(`/api/report/bookingItinerary?id=${this.booking.id}`);
            this.loaderActive = Utils.hideLoader();
            Utils.downloadBlob(document, blob, `BookingItinerary_${this.booking.id}.pdf`);
        }

        async confirmBookingModal(event: Event) {
            const button = ButtonToggler.getButton(event);
            ButtonToggler.disableButton(button);
            if (!await this.isValid()) {
                this.validationToastr(this.booking)
                ButtonToggler.enableButton(button);
                return;
            }
            ButtonToggler.enableButton(button);
            this.loaderActive = Utils.showLoader();
            await ApiClient.post("/Api/Booking/SaveBooking", this.booking, event);
            this.loaderActive = Utils.hideLoader();
            toastr.success("Saved");
            this.requiresSave = false;
            this.loaderActive = Utils.showLoader();
            const dialogue = this.$refs.confirmBookingModal as ConfirmBookingModal & { showFromModal: () => void };
            this.loaderActive = Utils.hideLoader();
            dialogue.showFromModal(this.booking);
        }

        async emailItinerary() {
            this.loaderActive = Utils.showLoader();
            const dialogue = this.$refs.itineraryReportSendModal as ItineraryReportSendModal & { show: () => void };
            this.loaderActive = Utils.hideLoader();
            dialogue.show(this.booking.id);
        }

        private async bookingAvailableEmployeeSearch(text: string) {
            this.availableEmployees = [];
            const response = await ApiClient.get(`/Api/Booking/BookingAvailableEmployeeSearch?contractorID=${this.booking.contractorID}&bookingID=${this.booking.id}&searchText=${text}`);
            this.availableEmployees.push(...response.map((e: IEmployeeVM) => new EmployeeVM(e)));
        }

        openScanReportModal(bookingData: BookingVM) {
            const dialogue = this.$refs.scanReportModal as ScanReportModal & { open: () => void };
            dialogue.open(bookingData.id);
        }

        // from https://github.com/vuelidate/vuelidate/issues/179
        private waitForValidation() {
            return new Promise<void>(resolve => {
                if (this.$v.$error || !this.$v.$pending) {
                    return resolve();
                }
                const poll = setInterval(() => {
                    if (!this.$v.$pending) {
                        clearInterval(poll)
                        resolve()
                    }
                }, 200);
            })
        }

        validationToastr(booking: BookingVM) {
            // if (typeof this.$v.booking.worksPostCode?.required != "undefined" && !this.$v.booking.worksPostCode?.required) { toastr.warning("Postcode is required"); }
            if (typeof this.$v.booking.worksLatitude?.isNonZero != "undefined" && !this.$v.booking.worksLatitude?.isNonZero) { toastr.warning("Location is required"); }
            if (typeof this.$v.booking.firstStay?.required != "undefined" && !this.$v.booking.firstStay?.required) { toastr.warning("First stay is required"); }
            if (typeof this.$v.booking.lastStay?.required != "undefined" && !this.$v.booking.lastStay?.required) { toastr.warning("Last stay is required"); }
            if (typeof this.$v.booking.description?.required != "undefined" && !this.$v.booking.description?.required) { toastr.warning("Description is required"); }
            if (typeof this.$v.booking.defaultNightsPerStay?.isNonZero != "undefined" && !this.$v.booking.defaultNightsPerStay?.isNonZero) { toastr.warning("Default Rooms per Day is required"); }
            if (this.$v.booking.latestArrivalDefault?.hasTime != true) { toastr.warning("Latest arrival is required"); }
        }

        @Validations()
        validations() {
            const validations = {
                booking: {} as any
            };
            // validations.booking.worksPostCode = { required };
            validations.booking.worksLatitude = { isNonZero: (value: number) => +value > 0 };
            validations.booking.description = { required };
            validations.booking.firstStay = { required };
            validations.booking.lastStay = { required };
             validations.booking.latestArrivalDefault = { hasTime: (value: Date) => {
                if (!value) {
                    return false;
                }
                if (value.getMinutes() !== 0 && value.getMinutes() !== 30) {
                    return false;
                }
                if (value.getTime() === Utils.emptyDateValue) {
                    return false;
                }
                return true;
            }};
            //validations.booking.defaultNightsPerStay = { isNonZero: (value: number) => +value > 0  };
            return validations;
        }
    }

